import {Pagination, LegacyCard} from "@shopify/polaris";

const Paginator = ({
                       show = false,
                       currentPage = 1,
                       lastPage = 1,
                       callback
}) => {
    if (! show) {
        return null;
    }

    return (
        <LegacyCard.Section>
            <Pagination
                label={`Showing Page ${currentPage} of ${lastPage}`}
                hasPrevious={ currentPage > 1}
                onPrevious={() => { callback( currentPage - 1) }}
                hasNext={ currentPage < lastPage }
                onNext={() => { callback( currentPage + 1) }} />
        </LegacyCard.Section>
    );
}

export default Paginator;
